import React from 'react';
import PropTypes from 'prop-types';
import TimeAgoAndDate from 'app/components/TimeAgoAndDate';

const TIME_AGO_PROPS = { TypographyProps: { variant: 'caption' } };

export default function ChangelogDateCell({ createdAt }) {
  return <TimeAgoAndDate timestamp={createdAt} TimeAgoProps={TIME_AGO_PROPS} />;
}

ChangelogDateCell.propTypes = {
  createdAt: PropTypes.string.isRequired,
};
